import React from "react";
import { Reveal } from "@/components/shared/Reveal";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { MANIFESTO, IMAGES } from "@/data/site";

export const Manifesto = () => {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="manifesto">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <SectionHeading
              eyebrow="Why Agarwal Secure"
              title="Relocation, reimagined as a craft."
              description="Three principles have guided every move we make since 1999 — care in the packing, precision in the transit, and trust earned over two decades."
            />
            <Reveal delay={0.2} className="mt-10 rounded-3xl overflow-hidden shadow-card ring-1 ring-brand/10">
              <img src={IMAGES.warehouse} alt="Warehouse team at work" className="w-full h-72 object-cover" loading="lazy" />
            </Reveal>
          </div>

          <div className="lg:col-span-7 space-y-4">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.no} delay={i * 0.1}>
                <div className="group relative flex gap-6 rounded-3xl border border-gray-100 bg-surface p-8 hover:bg-white hover:shadow-card transition-[background-color,box-shadow] duration-300">
                  <span className="font-heading font-extrabold text-6xl sm:text-7xl leading-none text-brand-light group-hover:text-brand-accent/30 transition-colors duration-300 select-none">
                    {m.no}
                  </span>
                  <div className="pt-1">
                    <h3 className="font-heading font-bold text-2xl text-ink">{m.title}</h3>
                    <p className="mt-3 text-muted-foreground leading-relaxed max-w-lg">{m.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
